import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  public baseUrl = environment.baseUrl;
  public avatarName: string = ''

  @Input() title: string | null = '';
  @Input() subtitle: string | null = '';
  @Input() set userName(name: string){
    this.avatarName = name.toLocaleUpperCase();
  }
  @Input() image: string | null = '';

  onMissingImage(event: Event) {
    (event.target as HTMLImageElement).src = `${this.baseUrl}/assets/images/avatar-default.png`;
    this.image = null;
  }
}
